import { createColumnHelper } from '@tanstack/react-table';

import { DataTableObject, TableConfigType } from '@/components/PatientDataTable';
import { DETAILS_SIDE_PANEL } from '@/components/PatientDataTable/consts';
import { isUs } from '@/globalConsts';
import { PatientObject } from '@/types';
import { isRealNhsNumber } from '@/utils';
import { formatScreeningStatus } from '@/utils/statusUtils';

import { TRIAL_SITES } from '../consts';

const columnHelper = createColumnHelper<DataTableObject>();

const columns = [
	columnHelper.accessor('identifier', {
		header: () => TRIAL_SITES.CONFIGS.PATIENT_LIST.TABLE.COLUMNS.A.LABEL,
		cell: (info) => info.getValue(),
		enableSorting: true,
	}),
	columnHelper.display({
		id: TRIAL_SITES.CONFIGS.PATIENT_LIST.TABLE.COLUMNS.B.ID,
		header: () => TRIAL_SITES.CONFIGS.PATIENT_LIST.TABLE.COLUMNS.B.LABEL,
		cell: (props) => {
			const { Element } = formatScreeningStatus(props.row.original as PatientObject, 'trial');
			return Element;
		},
		enableSorting: true,
	}),
	columnHelper.accessor(
		(row) =>
			`${(row as PatientObject).patient_first_name} ${
				(row as PatientObject).patient_last_name
			}`,
		{
			header: () => TRIAL_SITES.CONFIGS.PATIENT_LIST.TABLE.COLUMNS.C.LABEL,
			id: TRIAL_SITES.CONFIGS.PATIENT_LIST.TABLE.COLUMNS.C.ID,
		}
	),
	columnHelper.accessor('nhs_number', {
		header: () => TRIAL_SITES.CONFIGS.PATIENT_LIST.TABLE.COLUMNS.D.LABEL,
		cell: (info) =>
			isUs || isRealNhsNumber(info.getValue() as string) ? info.getValue() : null,
		enableSorting: true,
	}),
	columnHelper.accessor('provider_name', {
		header: () => TRIAL_SITES.CONFIGS.PATIENT_LIST.TABLE.COLUMNS.E.LABEL,
		cell: (info) => info.getValue() || null,
		enableSorting: true,
	}),
];

const rowProps = {
	batchSelect: false,
	onRowClickTarget: DETAILS_SIDE_PANEL,
	rowSelect: (status: number) => (status === 8000 || status === 2000 ? false : true),
	getRowId: (row: DataTableObject) => (row as PatientObject).id,
};

export const trialSitePatientTableConfig: TableConfigType = {
	columns: columns,
	rowProps: rowProps,
	defaultTabIndex: TRIAL_SITES.CONFIGS.PATIENT_DETAILS.TABS.DEFAULT_TAB,
};
